import { useQuery } from "@tanstack/react-query";
import { useLanguage } from "../context/LanguageContext";
import { publicBlogPostQueryOptions } from "../lib/publicContentQueries";

export const usePublicBlogPost = (id) => {
  const { language } = useLanguage();

  return useQuery(publicBlogPostQueryOptions(id, language));
};
